import { useEffect, useRef } from "react";
import { FormattedMessage, useIntl } from 'react-intl';

import Button from '@mui/material/Button';

import { baseUrl } from "../../api/api";

import { ERROR_CSRF_MISMATCH } from "../../constants/alertMsg";

import logoGoogle from '../../assets/images/logo_google.png';


const GoogleLoginButton = (props) => {
  const intl = useIntl();
  const { handleSubmit, media } = props;
  const codeClientRef = useRef(null);

  const initCodeClient = () => {
    const stateVal = crypto.randomUUID?.() || Math.random().toString(36);

    codeClientRef.current = window.google.accounts.oauth2.initCodeClient({
      client_id: baseUrl.googleClientId,
      scope: 'https://www.googleapis.com/auth/adwords openid email profile', // Google Ads 全權限
      access_type: 'offline', // 取回 refresh token
      prompt: 'select_account consent', // 強制再次選帳號並顯示同意窗
      ux_mode: 'popup', // 不跳轉頁面
      state: stateVal, // CSRF 防護
      callback: (res) => {
        const { code, state } = res;
        console.log('GoogleLogin_res', res);

        if (state !== stateVal) { // CSRF 檢查
          const message = intl.formatMessage({ id: ERROR_CSRF_MISMATCH, defaultMessage: '授權流程驗證失敗，請重新嘗試。' });
          window.alert(message);
          console.log('CSRF mismatch');
          return;
        }
        handleSubmit({
          media,
          query: { accessToken: code }
        });
      }
    });
  };

  useEffect(() => {
    initCodeClient();
  }, []);

  return (
    <>
      <div id="buttonDiv">
        <Button
          variant="auth-outlined"
          onClick={() => codeClientRef.current.requestCode()}
          sx={{ width: '300px' }}
        >
          <img src={logoGoogle} alt="Google Login" style={{ width: '24px' }} />
          <FormattedMessage id="account.modal.ContinueAccount" values={{ media: 'Google' }} />
        </Button>
      </div>
    </>
  )
}

export default GoogleLoginButton;